import { render, staticRenderFns } from "./list_top.vue?vue&type=template&id=a6055e06"
import script from "./list_top.vue?vue&type=script&lang=js"
export * from "./list_top.vue?vue&type=script&lang=js"
import style0 from "./list_top.vue?vue&type=style&index=0&id=a6055e06&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports